// The internal-dashboard sidebar now uses the same component as the client
// sidebar — only the menu items differ. This file is kept as a thin re-export
// so existing import paths (InternalDashboardRoutes.js etc.) keep working.
export { InternalSidebar as default } from '../../sidebar';
